import { Grid, Stack, Typography } from "@mui/material";
import MultiProgress from "react-multi-progress";

function MultiColorProgressbar({ elements, withLabel, labels }) {
  return (
    <Stack>
      <Grid item xs={12}>
        <MultiProgress
          round={false}
          roundLastElement={false}
          elements={elements}
          backgroundColor="#bdbdbd"
        />
      </Grid>
      <Grid item xs={12} sx={{ mt: 1 }}>
        {withLabel && (
          <Grid container>
            {labels.map((item, index) => (
              <Grid item key={`multicolor-progress-label-${index}`}>
                <Typography
                  sx={{
                    display: "list-item",
                    marginLeft: "1em",
                    marginRight: "1em",
                    color: item.color,
                  }}
                  fontSize={12}
                >
                  {item.label} {item.value}%
                </Typography>
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Stack>
  );
}

export { MultiColorProgressbar };
